import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IStatistic2ReportParameter } from '@fi-app/statistic2/statistic2';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-statistic2-add-existing-report-dialog',
    template: `
        <div class="statistic2-add-existing-report-description">
          {{ 'statistic.add_existing_report_description' | fiAppText }}
        </div>
        <mat-form-field appearance="fill">
          <mat-select [(value)]="selectedReportParameter" placeholder="{{ 'statistic.select.report' | fiAppText }}">
            @for (reportParameter of data; track reportParameter) {
              <mat-option [value]="reportParameter">
                {{ reportParameter.Name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        `,
    styleUrls: ['./statistic2-add-existing-report-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class Statistic2AddExistingReportDialogComponent extends FiDialogsContentBase<
    IStatistic2ReportParameter[],
    IStatistic2ReportParameter
> {
    selectedReportParameter: IStatistic2ReportParameter;

    isYesButtonDisabled() {
        return !this.selectedReportParameter;
    }

    getResult() {
        return this.selectedReportParameter;
    }
}
